<template>
	<div class="register-container">
		<img class="popularBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="register-content">
			<!-- Logo -->
			<div class="logo-container">
				<img src="../assets/logo.png" class="logo" />
			</div>
			<el-form ref="baseInfoForm" class="register-form" :model="baseInfoForm" :rules="baseInfoRules"
				label-width="100px" inline>
				<el-form-item label="" prop="nickname">
					<div class="form-group" style="width: 3.85rem;">
						<input type="text" v-model="baseInfoForm.nickname" placeholder="请输入昵称" class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="" prop="password">
					<div class="form-group" style="width: 3.85rem;">
						<input :type="showOldPwd ? 'text' : 'password'" v-model="baseInfoForm.password"
							placeholder="请输入登录密码" class="form-input" />
						<img class="showPwd" src="../assets/Personal/iconP.png" @click="showOldPwd = !showOldPwd"
							v-if="!showOldPwd" />
						<img class="showPwd" src="../assets/Personal/iconO.png" @click="showOldPwd = !showOldPwd"
							v-else />
					</div>
				</el-form-item>
				<el-form-item label="" prop="title">
					<div class="form-group" style="width: 3.85rem;">
						<input type="email" v-model="baseInfoForm.email" placeholder="请输入邮箱（选填）" class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="" prop="phone">
					<div class="form-group" style="width: 3.85rem;">
						<div class="phone-input-container">
							<input type="tel" v-model="baseInfoForm.phone" maxlength="11" placeholder="请输入手机号码"
								class="phone-input" />
							<button type="button" @click="getVerificationCode" :disabled="countdown > 0"
								class="get-code-btn">{{countdown > 0 ? countdown + 's后重新获取': '获取验证码'}}</button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="" prop="verificationCode">
					<div class="form-group" style="width: 3.85rem;">
						<div class="verification-container">
							<input type="text" v-model="baseInfoForm.verificationCode" placeholder="请输入验证码"
								class="verification-input" />
							<span v-if="showVerificationError" class="error-message">验证码错误</span>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="" prop="inviteCode">
					<div class="form-group" style="width: 3.85rem;">
						<div class="invite-container">
							<input type="text" v-model="baseInfoForm.inviteCode" placeholder="请输入邀请码（选填）"
								class="invite-input" />
							<span v-if="showInviteError" class="error-message">邀请码错误</span>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<div class="agreement-container">
				<label class="agreement-label">
					<img class="agreement-checkbox" src="../assets/Register/checkSel.png" v-if="baseInfoForm.agreeTerms"
						@click="baseInfoForm.agreeTerms = false" />
					<img class="agreement-checkbox" src="../assets/Register/checkNor.png" v-else
						@click="baseInfoForm.agreeTerms = true" />
					<span class="agreement-text">我已阅读并同意</span>
					<div class="agreement-link" @click="userAgree = true">《岱屿画境AI创作平台用户服务协议》</div>
				</label>
			</div>

			<!-- 注册按钮 -->
			<button type="button" @click="register" class="register-btn">注册</button>

			<!-- 登录链接 -->
			<div class="login-link-container">
				<router-link to="/login" class="login-link">已有账号，去登录</router-link>
			</div>
			<!-- 注册表单 -->
			<form class="register-form" v-if="false">
				<!-- 昵称输入 -->
				<div class="form-group">
					<input type="text" v-model="nickname" placeholder="请输入昵称" class="form-input" />
				</div>

				<!-- 密码输入 -->
				<div class="form-group">
					<input type="password" v-model="password" placeholder="请输入登录密码" class="form-input" />
				</div>

				<!-- 邮箱输入 -->
				<div class="form-group">
					<input type="email" v-model="email" placeholder="请输入邮箱（选填）" class="form-input" />
				</div>

				<!-- 手机号输入 -->
				<div class="form-group">
					<div class="phone-input-container">
						<input type="tel" v-model="phone" placeholder="请输入手机号码" class="phone-input" />
						<button type="button" @click="getVerificationCode" class="get-code-btn">获取验证码</button>
					</div>
				</div>

				<!-- 验证码输入 -->
				<div class="form-group">
					<div class="verification-container">
						<input type="text" v-model="verificationCode" placeholder="请输入验证码" class="verification-input" />
						<span v-if="showVerificationError" class="error-message">验证码错误</span>
					</div>
				</div>

				<!-- 邀请码输入 -->
				<div class="form-group">
					<div class="invite-container">
						<input type="text" v-model="inviteCode" placeholder="请输入邀请码（选填）" class="invite-input" />
						<span v-if="showInviteError" class="error-message">邀请码错误</span>
					</div>
				</div>

				<!-- 服务协议 -->
				<div class="agreement-container">
					<label class="agreement-label">
						<img class="agreement-checkbox" src="../assets/Register/checkSel.png" v-if="agreeTerms" />
						<img class="agreement-checkbox" src="../assets/Register/checkNor.png" v-else />
						<span class="agreement-text">我已阅读并同意</span>
						<a class="agreement-link" @click="userAgree = true">《岱屿画境AI创作平台用户服务协议》</a>
					</label>
				</div>

				<!-- 注册按钮 -->
				<button type="button" @click="register" class="register-btn">注册</button>

				<!-- 登录链接 -->
				<div class="login-link-container">
					<a href="/login">已有账号，去登录</a>
				</div>
			</form>
		</div>
		<div class="copyright">
			Copyright © 2025 岱屿画境 京ICP备2025019184号-2 <img class="police" src="../assets/Register/police.png"
				alt="" />浙公网安备33010202005149号
		</div>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'恭喜您已成功注册岱屿画境AI创作平台，马上开启您的探索之旅吧！'"
			@clickOk="sucPop = false;$router.push('/personal-like')" v-if="sucPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="'您好，当前手机号已注册'" :descTwo="'请输入新的手机号'"
			@clickOk="tipPop = false" v-if="tipPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/abnormal.png')" :desc="'登录异常'" @clickOk="abnormalPop = false"
			v-if="abnormalPop" />
		<UserSeverAgreeDialog :show="userAgree" @close="userAgree = false" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import UserSeverAgreeDialog from '../components/UserSeverAgreeDialog.vue'
	export default {
		name: 'RegisterPage',
		components: {
			PopToast,
			UserSeverAgreeDialog,
		},
		data() {
			return {
				baseInfoForm: {
					nickname: '',
					password: '',
					email: '',
					phone: '',
					verificationCode: '',
					inviteCode: '',
					agreeTerms: true,
				},
				nickname: '',
				password: '',
				email: '',
				phone: '',
				verificationCode: '',
				inviteCode: '',
				agreeTerms: true,
				showVerificationError: false,
				showInviteError: false,
				countdown: 0,
				sucPop: false,
				tipPop: false,
				showOldPwd: false,
				abnormalPop: false,
				userAgree: false,
				baseInfoRules: {
					nickname: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入登录密码',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}],
					verificationCode: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					agreeTerms: [{
						required: true,
						message: '请阅读并同意用户协议',
					}],
				}
			}
		},
		methods: {
			// 获取验证码
			getVerificationCode() {
				this.$refs.baseInfoForm.validateField('phone', (valid) => {
					if (!valid) {
						this.$api.post('/Other/phone_code', {
							phone: this.baseInfoForm.phone,
						}).then(res => {
							if (res.code == 1) {
								this.countdown = 60;
								// 倒计时
								const timer = setInterval(() => {
									this.countdown--;
									if (this.countdown <= 0) {
										clearInterval(timer);
									}
								}, 1000);
							} else {
								console.log(res.msg)
							}
							console.log(res)
						}).catch(err => {
							console.log(err);
						})
					} else {
						return
					}
				});
				// if (!this.phone) {
				// 	alert('请输入手机号码');
				// 	return;
				// }

				// // 模拟发送验证码
				// console.log('发送验证码到:', this.phone);
				// this.countdown = 60;

				// // 倒计时
				// const timer = setInterval(() => {
				// 	this.countdown--;
				// 	if (this.countdown <= 0) {
				// 		clearInterval(timer);
				// 	}
				// }, 1000);
			},

			// 注册
			register() {
				this.$refs.baseInfoForm.validate((valid) => {
					if (valid) {
						if (!this.baseInfoForm.agreeTerms) return this.$message.error('请阅读并同意用户协议')
						this.$api.post('/Basics/register', {
							user_nickname: this.baseInfoForm.nickname,
							user_email: this.baseInfoForm.email,
							mobile: this.baseInfoForm.phone,
							pwd: this.baseInfoForm.password,
							code: this.baseInfoForm.verificationCode,
							tj_num: this.baseInfoForm.inviteCode,
						}).then(res => {
							if (res.code == 1) {
								localStorage.setItem('token', res.data)
								this.showVerificationError = false
								this.showInviteError = false
								this.$api.post('/UserD/user_details', {}).then(response => {
									if (response.code == 1) {
										localStorage.setItem('userId', response.data.id)
										this.$store.dispatch('updateShopStatus', response.data
											.shop_status)
										this.$router.replace('/')
									}
								}).catch(err => {
									console.log(err);
								})
								this.sucPop = true
							} else {
								if (res.msg == "手机号已存在") {
									this.tipPop = true
									this.showInviteError = false
									this.showVerificationError = false
								} else if (res.msg == "验证码错误" || res.msg == "请先获取验证码") {
									this.showVerificationError = true
									this.showInviteError = false
								} else if (res.msg == "推荐码错误") {
									this.showVerificationError = false
									this.showInviteError = true
								} else {
									this.abnormalPop = true
								}
							}
						}).catch(err => {
							this.abnormalPop = true
							console.log(err);
						})
					} else {
						return false
					}
				})
				// 表单验证
				// if (!this.nickname || !this.password || !this.phone || !this.verificationCode) {
				// 	alert('请填写必填项');
				// 	return;
				// }

				// if (!this.agreeTerms) {
				// 	alert('请阅读并同意服务协议');
				// 	return;
				// }

				// // 模拟验证过程
				// // 这里仅作演示，实际项目中应该调用API
				// this.showVerificationError = false;
				// this.showInviteError = false;

				// // 模拟验证码错误的情况
				// if (this.verificationCode !== '123456') {
				// 	this.showVerificationError = true;
				// 	return;
				// }

				// // 模拟邀请码错误的情况
				// if (this.inviteCode && this.inviteCode !== 'INVITE123') {
				// 	this.showInviteError = true;
				// 	return;
				// }

				// // 注册成功
				// console.log('注册成功:', {
				// 	nickname: this.nickname,
				// 	phone: this.phone,
				// 	email: this.email,
				// 	inviteCode: this.inviteCode
				// });

				// // 注册成功后跳转到首页
				// this.$router.push('/');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.register-container {
		width: 100%;
		height: 100vh;
		background: #FAEFDD;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		.popularBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.register-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 5.05rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		z-index: 1;
	}

	.logo-container {
		margin-top: 0.5rem;

		.logo {
			width: 1.5rem;
			height: .3rem;
		}
	}

	// 表单样式
	.register-form {
		width: 3.85rem;
		margin-top: .32rem;
	}

	.form-group {
		// margin-top: .16rem;
		position: relative;

		.showPwd {
			position: absolute;
			top: calc(50% - .12rem);
			right: .1rem;
			width: .24rem;
			height: .24rem;
			cursor: pointer;
		}
	}

	.form-input {
		width: 100%;
		height: 0.44rem;
		border: .01rem solid #EFD8B8;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		font-size: 0.14rem;
		color: #333333;
		outline: none;
		transition: border-color 0.3s ease;

		// &:focus {
		// 	border-color: #E29358;
		// }

		&::placeholder {
			color: #999999;
		}
	}

	// 手机号和验证码输入框样式
	.phone-input-container,
	.verification-container,
	.invite-container {
		width: 100%;
		height: 0.44rem;
		border: .01rem solid #EFD8B8;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		font-size: 0.14rem;
		color: #333333;
		outline: none;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.phone-input,
	.verification-input,
	.invite-input {
		border: none;
		outline: none;
		padding: 0 0;

		font-size: 0.14rem;
		color: #333333;

		&::placeholder {
			color: #999999;
		}
	}

	.get-code-btn {
		padding: 0 0;
		color: #E29358;
		font-size: 0.14rem;
		cursor: pointer;

		&:disabled {
			background: #FFFFFF;
			color: #CCCCCC;
			border-color: #CCCCCC;
			cursor: not-allowed;
		}
	}

	// 错误提示样式
	.error-message {
		background: #F56C6C;
		padding: 0.04rem 0.09rem;
		border-radius: 0.02rem;
		font-weight: 400;
		font-size: 0.12rem;
		color: #FFFFFF;
		line-height: .22rem;
	}

	// 服务协议样式
	.agreement-container {
		margin: 0.16rem 0 0;
		font-size: 0.14rem;
	}

	.agreement-label {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.agreement-checkbox {
		margin-right: 0.08rem;
		width: .16rem;
		height: .16rem;
		cursor: pointer;
	}

	.agreement-text {
		font-weight: 400;
		color: #333333;
		margin-right: 0.04rem;
	}

	.agreement-link {
		font-weight: 400;
		color: #E29358;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	// 按钮样式
	.register-btn {
		margin: .24rem auto 0;
		width: 3.85rem;
		height: 0.52rem;
		background: #E29358;
		padding: 0 0;
		border: none;
		border-radius: 0.04rem;
		font-size: 0.16rem;
		color: #252525;
		font-weight: 500;
		line-height: .52rem;
		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover {
			background: #D17F3A;
		}
	}

	// 登录链接样式
	.login-link-container {
		margin-top: 0.16rem;
		margin-bottom: .5rem;
		width: 3.85rem;
		height: .52rem;
		background: #EFD8B8;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&:hover {
			.login-link {
				color: #E29358;
			}
		}
	}

	.login-link {
		font-weight: 400;
		font-size: .15rem;
		color: #252525;
		text-decoration: none;
	}

	.copyright {
		position: fixed;
		bottom: .16rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: 400;
		font-size: .12rem;
		color: #333333;
		display: flex;
		align-items: center;

		.police {
			margin-left: .12rem;
			margin-right: .04rem;
			width: .14rem;
			height: .14rem;
		}
	}

	::v-deep .el-form-item {
		margin-right: 0 !important;
		margin-bottom: .16rem !important;
		font-size: .14rem;
		line-height: 0.44rem;

		&__content {
			font-size: .14rem;
			line-height: 0.44rem;
		}

		&__error {
			font-size: .12rem;
			padding-top: .02rem;
		}
	}
</style>